import * as tslib_1 from "tslib";
import { FormGroup } from '@angular/forms';
import { v4 as uuid } from 'uuid';
import { ViewQrCodeModalService } from '../../../../../../core/components/view-qr-code-modal/view-qr-code-modal.service';
import { CustomMessagesService } from '../../../../../../core/errors/custom-messages.service';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(messageService, viewQrCodeModalService) {
        this.messageService = messageService;
        this.viewQrCodeModalService = viewQrCodeModalService;
    }
    TabGeneralComponent.prototype.generateQrCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.locationEnvironmentForm.get('qrCode').setValue(uuid());
                this.openQrCodeDialog();
                this.messageService.success('LOCATION_ENVIRONMENT_DIALOG.MESSAGE.QR_CODE');
                return [2 /*return*/];
            });
        });
    };
    TabGeneralComponent.prototype.openQrCodeDialog = function () {
        var _a = this.locationEnvironmentForm.value, qrCode = _a.qrCode, name = _a.name;
        this.viewQrCodeModalService.open({
            qrCode: qrCode,
            fileName: name
        });
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
